import { SetState } from 'zustand';
import type { InstallMeterStore } from '../../useStore';
import { InstallationTechnology } from '../../const/installationTechnology';

export interface InstallationTechnologyForm {
  installationTechnology: InstallationTechnology | null;
}

const INITIAL_STATE: InstallationTechnologyForm = {
  installationTechnology: null,
};

export type InstallationTechnologyStepSlice = InstallationTechnologyForm & {
  resetInstallationTechnologyStepSlice: (initValues?: Partial<InstallationTechnologyForm>) => void;
  setInstallationTechnologyStepValues: (values: InstallationTechnologyForm) => void;
};

export const createInstallationTechnologyStepSlice = (
  set: SetState<InstallMeterStore>,
): InstallationTechnologyStepSlice => ({
  ...INITIAL_STATE,
  resetInstallationTechnologyStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
  setInstallationTechnologyStepValues: (values: InstallationTechnologyForm) => set(values),
});
